import { ZodObjecty } from '@repo/types/Types';
import { DeepPartial } from 'react-hook-form';
import { z } from 'zod';

// https://github.com/colinhacks/zod/discussions/1953
export function getZodDefaults<Schema extends ZodObjecty>(
  schema: Schema | z.ZodDiscriminatedUnion
): DeepPartial<z.infer<Schema>> {
  if (schema instanceof z.ZodDiscriminatedUnion) {
    const firstOption = schema.options[0] as ZodObjecty;
    return getZodDefaults(firstOption) as DeepPartial<z.infer<Schema>>;
  }
  const shape = schema.shape;
  return Object.fromEntries(
    Object.entries(shape).map(([key, value]) => {
      if (value instanceof z.ZodDefault) {
        return [key, value.def.defaultValue];
      }
      return [key, undefined];
    })
  ) as DeepPartial<z.infer<Schema>>;
}
